import { render, staticRenderFns } from "./add-moodle-instance-modal.vue?vue&type=template&id=350fe7fb&scoped=true"
import script from "./add-moodle-instance-modal.vue?vue&type=script&lang=js"
export * from "./add-moodle-instance-modal.vue?vue&type=script&lang=js"
import style0 from "./add-moodle-instance-modal.vue?vue&type=style&index=0&id=350fe7fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350fe7fb",
  null
  
)

export default component.exports